import { createTheme } from '@mui/material/styles';

const createAppTheme = (settings = {}) => {
  const {
    primary_color = '#1565c0',
    secondary_color = '#e53935',
    theme_mode = 'light'
  } = settings;

  return createTheme({
    palette: {
      mode: theme_mode,
      primary: { main: primary_color },
      secondary: { main: secondary_color },
      background: {
        default: theme_mode === 'light' ? '#f0f2f5' : '#0a0a0a',
        paper: theme_mode === 'light' ? '#ffffff' : '#1a1a1a',
      },
    },
    typography: {
      fontFamily: ['-apple-system','BlinkMacSystemFont','"Segoe UI"','Roboto','Arial','sans-serif'].join(','),
      h4: { fontWeight: 700 },
      h5: { fontWeight: 600 },
      h6: { fontWeight: 600 },
    },
    shape: { borderRadius: 10 },
    components: {
      MuiButton: {
        styleOverrides: { root: { textTransform: 'none', borderRadius: 8, fontWeight: 600 } }
      },
      MuiCard: {
        styleOverrides: { root: { borderRadius: 14, boxShadow: '0 2px 12px rgba(0,0,0,0.08)' } }
      },
      MuiPaper: {
        styleOverrides: { root: { borderRadius: 14 } }
      },
      MuiTextField: {
        defaultProps: { variant: 'outlined', size: 'small', fullWidth: true }
      },
      MuiChip: {
        styleOverrides: { root: { fontWeight: 600 } }
      },
    },
  });
};

export default createAppTheme;
